import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useHospitalData } from "../../contexts/HospitalDataProvider";
import { Tooltip } from "../tooltip";
import Style from "./ChartScoreArea.module.scss";

type Props = {
	patientScore: string;
	patientScoreText: string;
	scoreColor: string;
	labelEnabled?: boolean;
	label?: string;
	/** Per-area breakdown, rendered inside the section so it sits above the separator. */
	breakdown?: ReactNode;
};
export const ChartScoreArea = ({ patientScore, patientScoreText, scoreColor, labelEnabled, label, breakdown }: Props) => {
	const { t } = useTranslation();
	// Demo styling is derived from context (Hospital type + inhouse2), not passed in.
	const { isHospitalView: isHospitalDemo } = useHospitalData();
	return (
		<div className={isHospitalDemo ? `${Style.dateAreaContainer} ${Style.demo}` : Style.dateAreaContainer}>
			<Tooltip
				id="workForce"
				text={t(labelEnabled ? "tooltip.workForce" : "tooltip.patientScore")}
				showTooltip={true}
				component={<div className={Style.patientScoreText}>{patientScoreText ? patientScoreText : ""}</div>}
			/>
			<div className={Style.containerParent}>
				<div className={Style.container}>
					<div
						// Score renders in the threshold color (demo separator/font come from the .demo class).
						style={{ color: scoreColor }}
						className={labelEnabled ? Style.patientScoreOverview : Style.patientScore}
					>
						{patientScore}
					</div>
				</div>
			</div>
			{
				// labelEnabled && <p className={Style.label}>Lorem ipsum dolor sit amet duis et consectetur adipiscing elit ull.</p>
				labelEnabled && <p className={Style.label}>{label}</p>
			}
			{breakdown}
		</div>
	);
};
